import { Typography } from 'antd';
import styled from 'styled-components';

export const GridRow = styled.div`
    display: grid;
    grid-template-columns: minmax(200px, max-content) 1fr;
    column-gap: 16px;
    align-items: center;
    width: 100%;
`;
export const Cell = styled.div`
    min-width: 0; /* allows ellipsis on the email cell */
`;

export const EmailCell = styled(Cell)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const OptionRows = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    width: 100%;
    padding-block: 2px;
`;

export const TopRow = styled.div`
    display: grid;
    grid-template-columns: minmax(150px, max-content) 1fr;
    column-gap: 24px;
    align-items: center;
    width: 100%;
    font-weight: 600;
`;

export const TruncatedText = styled(Typography)`
    display: block;
    width: 100%;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Header = styled.div`
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
    background: var(--gray-3);
    font-weight: 600;
`;
